import { MessageCircle } from "lucide-react";
import { WHATSAPP_SUPPORT } from "./layout/PublicFooter";

export default function FloatingWhatsApp() {
    return (
        <a
            href={WHATSAPP_SUPPORT.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label={`WhatsApp support ${WHATSAPP_SUPPORT.display}`}
            className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 hover:gap-3 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] pl-4 pr-4 h-14 hover:pr-5 transition-all duration-300"
        >
            <MessageCircle className="w-6 h-6 shrink-0 fill-white" />
            <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-[200px] transition-all duration-300 font-mono text-sm font-bold">
                {WHATSAPP_SUPPORT.display}
            </span>
        </a>
    );
}
